import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Center,
  ScrollView,
  Button,
  useToast,
  Stack,
  TextArea,
  View,
  FormControl,
  Pressable,
  Image,
  Input,
  Icon,
  ChevronUpIcon,
  IconButton,
  Checkbox,
  Divider,
  Card
} from "native-base";
import { GlobalStyles } from "../../constants/styles";
import FeedCard from "../../components/FeedCard";
import { GlobalConstants } from "../../constants/constants";
import { useNavigation } from "@react-navigation/native";
import Toast from "../../components/Toast";
import { useSelector } from "react-redux";
import axios from "axios";
import ConfigureSettingsPopup from "../../components/ConfigureSettingsPopup";
import { uploadImage } from "../../utils/general";
import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import FeedCardNew from "../../components/FeedCardNew";
import AdProductCardForBusiness from "../../components/AdProductCardForBusiness";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's CSS

//  Import service components 
import BusinessSurvey from "../../components/BusinessServices/BusinessSurvey";
import TicketManager from "../../components/BusinessServices/TicketManager";
import CouponManager from "../../components/BusinessServices/CouponManager";
import BusinessReservation from "../../components/BusinessServices/BusinessReservation";
import LoyaltyManager from "../../components/BusinessServices/LoyaltyManager";
import CustomerData from "../../components/BusinessServices/CustomerData";
import Subscription from "../../components/BusinessServices/Subscription";
import { SubscribeServiceButton, useUserServiceSubscriptions } from "../../components/BusinessServices/Subscription";

// for survey agent — import AgentChatWidget
import AgentChatWidget from "../../components/BusinessAgents/AgentChatWidget";

// END SERVICES NAVIGATION


const SERVICE_NAME_TO_KEY = {
  "Loyalty Points": "loyalty",
  "Coupons": "coupon",
  "Reservation System": "reservation",
  "Ticketing System": "ticket",
  "Survey": "survey",
  "Customer Data & Email System": "email",
};

const BusinessMainPage = () => {
  let user = useSelector((state) => state.user.user);
  axios.defaults.headers.common = {
    Authorization: `bearer ${user ? user.token : null}`,
  };
  console.log("user",user?.profile?.name)
  const toast = useToast();
  const navigation = useNavigation();

// Fetch user's active service subscriptions
const userId = user?.id || user?.user_id || null;
const { serviceMap, refetch: refetchServiceMap } = useUserServiceSubscriptions(userId);

  const [postTextArea, setPostTextArea] = useState("");
  const [postDetails, setPostDetails] = useState("");
  const [postType, setPostType] = useState(
    GlobalConstants.postCategories.tick.id
  );
  const [postImage, setPostImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editorContent, setEditorContent] = useState("");

  const [ticksBtnTextColor, setTicksBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );
  const [ticksBtnTextColorHead, setTicksBtnTextColorHead] = useState(
    GlobalStyles.colors.white
  );
  const [dealsBtnTextColorHead, setDealsBtnTextColorHead] = useState(
    GlobalStyles.colors.white
  );
  const [servicesBtnTextColorHead, setServicesBtnTextColorHead] = useState(
    GlobalStyles.colors.white
  );
  const [productsBtnTextColorHead, setProductsBtnTextColorHead] = useState(
    GlobalStyles.colors.white
  );
  const [dealsBtnTextColor, setDealsBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );
  const [servicesBtnTextColor, setServicesBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [productsBtnTextColor, setProductsBtnTextColor] = useState(
    GlobalStyles.colors.white
  );

  const [addTickBtnTextColor, setAddTickBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );

  const [addDealBtnTextColor, setAddDealBtnTextColor] = useState(
    GlobalStyles.colors.blue
  );

  const [createAdBtnTextColor, setCreateAdBtnTextColor] = useState(
    GlobalStyles.colors.white
  );
  const [createAdProduct, setCreateAdProduct] = useState(
    GlobalStyles.colors.blue
  );
  const [getAdProduct, setGetAdProduct] = useState(
    GlobalStyles.colors.blue
  );
  const [isTicksView, setIsTicksView] = useState(false);
  const [businessPosts, setBusinessPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePosts, setHasMorePosts] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [selectedPostCategoryId, setSelectedPostCategoryId] = useState(0);

  const [deletePopUp, setDeletePopUp] = useState(false);
  const [deletePopUpProduct, setDeletePopUpProduct] = useState(false);
  const [selectedPost, setSelectedPost] = useState({});
  const [remainingCharacters, setRemainingCharacters] = useState(300);
  const [remainingCharactersForDetail, setRemainingCharactersForDetail] = useState(1500);
  const boxRef = useRef(null);
  const box2Ref = useRef(null);
  const summaryRef = useRef(null);
  const detailRef = useRef(null);
  const [getTick, setGetTick] = useState(false);
  const [getDeal, setGetDeal] = useState(false);
  const [getServices, setGetServices] = useState(false);
  const [getProducts, setGetProducts] = useState(false);
  const [isProductView, setIsProductView] = useState(false);
  const [getAds, setGetAds] = useState(false);
  const [categoriesProd, setCategoriesProd] = useState([]);
  const [subCategoriesProd, setSubCategoriesProd] = useState([]);
  const [isAgentOff, setIsAgentOff]= useState(true);

  const [selectedCategoryProd, setSelectedCategoryProd] = useState(null);
  const [selectedSubCategoryProd, setSelectedSubCategoryProd] = useState(null); 
  const [selectedSubCategoryProdId, setSelectedSubCategoryProdId] = useState(null);
  const [titleProd, setTitleProd] = useState("");
  const [detailsProd, setDetailsProd] = useState("");
  const [postImageProd, setPostImageProd] = useState([]); // from upload
  const [listItems, setListItems] = useState([
    { id: 1, label: "New Arrivals" },
    { id: 2, label: "Popular This season" },
    { id: 3, label: "Men Arrivals" },
    { id: 4, label: "Spring Launch" },
  ]);
  const services = [
    { name: "Loyalty Points", icon: require("../../../assets/loyalty.png") },
    { name: "Coupons", icon: require("../../../assets/coupon.png") },
    { name: "Reservation System", icon: require("../../../assets/calendar.png") },
    { name: "Ticketing System", icon: require("../../../assets/ticket.png") },
    { name: "Survey", icon: require("../../../assets/survey.png") },
    { name: "Customer Data & Email System", icon: require("../../../assets/email.png") },
  ];
  const [tags, setTags] = useState([]); // ["Popular", "New Arrival"]
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addMode, setAddMode] = useState("single");
  
  // SERVICES NAVIGATION: State for showing service components 
  const [showSurvey, setShowSurvey] = useState(false);
  const [showTicketManager, setShowTicketManager] = useState(false);
  const [showCouponManager, setShowCouponManager] = useState(false);
  const [showReservation, setShowReservation] = useState(false);
  const [showLoyaltyManager, setShowLoyaltyManager] = useState(false);
  const [showCustomerData, setShowCustomerData] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  // END SERVICES

  // for survey agent 
  const [showAgentChat, setShowAgentChat] = useState(false);
  // for survey agent 
  const [showAgentComingSoon, setShowAgentComingSoon] = useState(false);
  
  const toggleImages = {
    on: require("../../../assets/switchtoggleOn.png"),
    off: require("../../../assets/switchtoggleOff.png"),
  };
  const COLORS = {
    primary: "#002061",
    border: "#E5E7EB",
    gray: "#6B7280",
    bg: "#F9FAFB",
  };

  // for survey agent 
  const resetServiceViews = () => {
    setShowSurvey(false);
    setShowTicketManager(false);
    setShowCouponManager(false);
    setShowReservation(false);
    setShowLoyaltyManager(false);
    setShowCustomerData(false);
    setShowSubscription(false);
    setShowAgentChat(false);
    setShowAgentComingSoon(false);
  };

  function changeColor(btnType) {
    if (btnType === "AddTick") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.mustard);
      setIsTicksView(false);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
      
      setPostType(GlobalConstants.postCategories.tick.id);
    } else if (btnType === "AddDeal") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.mustard);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
      setIsTicksView(false);
      setPostType(GlobalConstants.postCategories.deal.id);
    } else if (btnType === "CreateAd") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.white);
      setCreateAdBtnTextColor(GlobalStyles.colors.mustard);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
      setIsTicksView(false);
      setPostType(GlobalConstants.postCategories.ad.id);
    } else if (btnType === "Ticks") {
      setTicksBtnTextColor(GlobalStyles.colors.mustard);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
      
    } else if (btnType === "Deals") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.mustard);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
    } else if (btnType === "services") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.mustard);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
    }else if (btnType === "products") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdProduct(GlobalStyles.colors.mustard);
      setGetAdProduct(GlobalStyles.colors.blue);
    }else if (btnType === "AddProduct") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.mustard);
    }else if (btnType === "Product") {
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.blue);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdProduct(GlobalStyles.colors.mustard);
      setGetAdProduct(GlobalStyles.colors.blue);
    }else{
      setTicksBtnTextColor(GlobalStyles.colors.blue);
      setAddTickBtnTextColor(GlobalStyles.colors.mustard);
      setCreateAdBtnTextColor(GlobalStyles.colors.white);
      setAddDealBtnTextColor(GlobalStyles.colors.blue);
      setDealsBtnTextColor(GlobalStyles.colors.blue);
      setServicesBtnTextColor(GlobalStyles.colors.white);
      setProductsBtnTextColor(GlobalStyles.colors.white);
      setCreateAdProduct(GlobalStyles.colors.blue);
      setGetAdProduct(GlobalStyles.colors.blue);
      setIsTicksView(false);
      setGetTick(true);
      setGetDeal(false);
    }
  }

  function changeColorHead(btnType){
    if (btnType === "Ticks") {
      setTicksBtnTextColorHead(GlobalStyles.colors.mustard);
      setDealsBtnTextColorHead(GlobalStyles.colors.white);
      setServicesBtnTextColorHead(GlobalStyles.colors.white);
      setProductsBtnTextColorHead(GlobalStyles.colors.white);
      changeColor("Ticks")
    }else if (btnType === "services") {
      setTicksBtnTextColorHead(GlobalStyles.colors.white);
      setDealsBtnTextColorHead(GlobalStyles.colors.white);
      setServicesBtnTextColorHead(GlobalStyles.colors.mustard);
      setProductsBtnTextColorHead(GlobalStyles.colors.white);
      changeColor("services")
    }else if (btnType === "products") {
      setTicksBtnTextColorHead(GlobalStyles.colors.white);
      setDealsBtnTextColorHead(GlobalStyles.colors.white);
      setServicesBtnTextColorHead(GlobalStyles.colors.white);
      setProductsBtnTextColorHead(GlobalStyles.colors.mustard);
      changeColor("products")
    }
    else{
      setTicksBtnTextColorHead(GlobalStyles.colors.white);
      setDealsBtnTextColorHead(GlobalStyles.colors.mustard);
      setServicesBtnTextColorHead(GlobalStyles.colors.white);
      changeColor("Deals")
    }
  }

  const createPost = async () => {
    try {
      var obj = {
        text: postTextArea,
        details: postDetails,
        type: postType,
      };
      
      if (postImage.length > 0) {
        obj.urls = postImage
        
      }
      setIsLoading(true);
      const resp = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}posts`,
        obj
      );
      if (resp.data.status) {
        setPostImage([]);
        setPostTextArea("");
        setPostDetails("");
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.mustard}
                message={
                  GlobalConstants.postCategories[
                    postType == 1 ? "tick" : "deal"
                  ].title.toLowerCase() + " created successfuly!!!"
                }
              />
            );
          },
          placement: "top",
        });
      } else {
        // console.log(resp.data.status_msg," character count")
        toast.show({
          render: () => {
            return (
              <Toast
                color={GlobalStyles.colors.red}
                message={resp.data.status_msg}
              />
            );
          },
          placement: "top",
        });
      }
      setPostTextArea("");
      setPostDetails("");
      setIsLoading(false);
    } catch (error) {
      changeColor("AddTick");
      console.log(error);
    }
  };
    
  const handleCountInputChange = (value) => {
    
    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 300) {
      setPostTextArea(value);
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharacters(300 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 300);
      setPostTextArea(truncatedText);
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharacters(0);
    }
  };
  const handleCountInputChangeForDetail = (value) => {
    
    const plainTextLength = value.replace(/<[^>]*>/g, "").length;

    if (plainTextLength <= 1500) {
      setPostDetails(value);
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharactersForDetail(1500 - plainTextLength);
    } else {
      const truncatedText = truncateToLimit(value, 1500);
      setPostDetails(truncatedText);
      // if (boxRef.current) {
      //   const el = boxRef.current;
      //   requestAnimationFrame(() => {
      //     el.scrollTop = el.scrollHeight;
      //   });
      // }
      setRemainingCharactersForDetail(0);
     
    }
  };

  const truncateToLimit = (htmlContent, limit) => {
    const div = document.createElement("div");
    div.innerHTML = htmlContent;
  
    let charCount = 0;
    let reachedLimit = false;
  
    const truncateNode = (node) => {
      if (reachedLimit) return null;
  
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || "";
        if (charCount + text.length <= limit) {
          charCount += text.length;
          return document.createTextNode(text);
        } else {
          const remaining = limit - charCount;
          charCount = limit;
          reachedLimit = true;
          return document.createTextNode(text.slice(0, remaining));
        }
      }
  
      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false); // Shallow clone
        for (const child of node.childNodes) {
          const truncatedChild = truncateNode(child);
          if (truncatedChild) clone.appendChild(truncatedChild);
          if (reachedLimit) break;
        }
        return clone;
      }
  
      return null;
    };
  
    const truncated = truncateNode(div);
    const container = document.createElement("div");
    if (truncated) container.appendChild(truncated);
  
    return container.innerHTML;
  };




  const getPostsByCategoryId = async (categoryId, page = 1, reset = false) => {
    // If switching categories, reset the posts and page count
    if (selectedPostCategoryId !== categoryId || reset) {
      setBusinessPosts([]);      
      setCurrentPage(1);         
      setHasMorePosts(true);     
      setSelectedPostCategoryId(categoryId); // Update category
    }
  
    try {
      setIsLoadingMore(true); 
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}v1/posts/category/${categoryId}?page=${page}`
      );
  
      if (resp.data.status) {
        const newPosts = resp.data.data;
  
        setBusinessPosts((prevPosts) => {
          // Replace list if reset or it's the first page, else append
          return reset || page === 1 ? newPosts : [...prevPosts, ...newPosts];
        });
        if (newPosts.length < 10) {
          setHasMorePosts(false);
        } else {
          setCurrentPage((prev) => (reset ? page + 1 : prev + 1));
        }
      } else {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message={"Failed to get posts!"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoadingMore(false); 
    }
  };
  
  const loadMorePosts = () => {
  if (hasMorePosts && !isLoadingMore) {
    if(selectedPostCategoryId){
      getPostsByCategoryId(selectedPostCategoryId, currentPage, false);
    }else{
      getProductsById(currentPage, false);  
    }
    
  }
};

  const Delete = async () => {
    try {
      const config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${GlobalConstants.townTicksBaseUrl}posts`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          post_id: selectedPost.id,
        }),
      };
  
      const resp = await axios.request(config);
  
      if (resp.data.status) {
        // Show success toast
            toast.show({
              render: () => (
                <Toast
                  color={GlobalStyles.colors.mustard}
                  message="Post deleted successfully!"
                />
              ),
              placement: "top",
            });

            // Remove the deleted post locally
            setBusinessPosts((prevPosts) =>
              prevPosts.filter((post) => post.id !== selectedPost.id)
            );

            // Re-fetch current page to sync data without resetting pagination
            setTimeout(() => {
              getPostsByCategoryId(selectedPostCategoryId, 1, true); // only add new posts
            }, 2000);
            
      } else {
        toast.show({
          render: () => (
            <Toast color={GlobalStyles.colors.red} message={resp.data.status_msg} />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error deleting post:", error);
      toast.show({
        render: () => (
          <Toast color={GlobalStyles.colors.red} message="Error deleting post!" />
        ),
        placement: "top",
      });
    }
  };

  const handleDeleteOk = async (isTrue) => {
    setDeletePopUp(false);
    if (isTrue) {
      await Delete();
    }
  };

  const onDeleteClick = async (data) => {
    // console.log(data);
    setDeletePopUp(true);
    setSelectedPost(data);
  };
  const handleDeleteOkProduct = async (isTrue) => {
    setDeletePopUpProduct(false);
    if (isTrue) {
      console.log("id",selectedPost)
      await DeleteProduct(selectedPost);
      await getProductsById();

    setSelectedPost(null);
    }
  };
 
  const onDeleteClickProduct = async (id) => {
    // console.log(data);
    setDeletePopUpProduct(true);
    setSelectedPost(id);
  };

  const DeleteProduct = async (productId) => {
    try {
      if (!productId) {
        console.log("Product ID is required");
        return;
      }
  
      const response = await axios.delete(
        `${GlobalConstants.townTicksBaseUrl}/products`,
        {
          data: { id: productId }, // DELETE body
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Product deleting");
      if (response.data?.status) {
        toast.show({
          render: () => (
            <Toast color="green" message="Product deleted successfully" />
          ),
          placement: "top",
        });
      } else {
        toast.show({
          render: () => (
            <Toast
              color="red"
              message={response.data?.status_msg || "Delete failed"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      console.log(
        "Delete product error:",
        error?.response?.data || error.message
      );
  
      toast.show({
        render: () => (
          <Toast
            color="red"
            message="Something went wrong while deleting product"
          />
        ),
        placement: "top",
      });
    }
  };
  ///check vedio
  const isVideo = (media) => {
    const uri = media?.uri || media?.url || "";
    return /\.(mp4|mov|webm|mkv)$/i.test(uri);
  };
  async function selectFile() {
    setIsLoading(true);
    let imageUrl = await uploadImage(user.token);
    if (imageUrl) {
      // console.log(imageUrl,"url")
      setPostImage(prev => {
        const updated = [...prev, imageUrl];
        console.log("UPDATED postImage:", updated);
        return updated;
      });
      console.log(postImage)
      setIsLoading(false);
      // console.log(postImage,"set")
    } else {
      setIsLoading(false);
      toast.show({
        render: () => {
          return (
            <Toast
              color={GlobalStyles.colors.red}
              message={"please check image size should be less than 500KB!!!"}
            />
          );
        },
        placement: "top",
      });
    }
  }

  async function selectFileProd() {
    setIsLoading(true);
  
    try {
      const mediaUrl = await uploadImage(user.token);

      if (mediaUrl?.error) {
        toast.show({
          render: () => <Toast color="red" message={mediaUrl.error} />,
          placement: "top",
        });
        return;
      }

      if (mediaUrl) {
        setPostImage((prev) => [
          ...prev,
          {
            url: mediaUrl,
            type: mediaUrl.includes("video") ? "video/mp4" : "image/jpeg",
          },
        ]);
      }
    } catch (err) {
      console.error("Upload error:", err);
      toast.show({
        render: () => <Toast color="red" message="Upload failed!" />,
        placement: "top",
      });
    } finally {
      setIsLoading(false);
    }
  }
  const getListItems = async () => {
    try {
      const resp = await axios.get(`${GlobalConstants.townTicksBaseUrl}/products/fav`);
  
      if (resp.data?.status && Array.isArray(resp.data.data)) {
        const uniqueMap = new Map(); // key = category_id
  
        resp.data.data.forEach((item) => {
          const category = item.productCategory;
  
          if (!uniqueMap.has(category.id)) {
            uniqueMap.set(category.id, {
              id: category.id,               
              category_id: category.id,      
              label: `${category.parent.name}-${category.name}`,
            });
          }
        });
  
        setListItems(Array.from(uniqueMap.values()));
      }
    } catch (error) {
      console.log("Error fetching favorite products:", error);
    }
  };
  const handleMoveToList = async () => {
    if (!selectedSubCategoryProd) return;
  
    try {
      await axios.post(`${GlobalConstants.townTicksBaseUrl}/products/fav`, {
        category_id: selectedSubCategoryProd.id,
      });
      // setSelectedSubCategoryProd();
      // setSelectedCategoryProd();
      await getListItems(); // auto refresh
    } catch (error) {
      console.log("Add to fav failed:", error);
    }
  };
  const handleRemoveItem = async (id) => {
    try {
      await axios.delete(`${GlobalConstants.townTicksBaseUrl}/products/fav`, {
        data: { category_id: id },
      });
  
      await getListItems(); //  auto refresh
    } catch (error) {
      console.log("Remove from fav failed:", error);
    }
  };
  const handleCategorySelect = (category) => {
    setSelectedCategoryProd(category);
    setSubCategoriesProd(category.children || []);
    setSelectedSubCategoryProd(null); // reset subcategory
  };
  const handleSubCategorySelect = (subCategory) => {
    setSelectedSubCategoryProd(subCategory);
  };
  const getCategoryForProduct = async () => {
    setCategoriesProd([])
    try {
      setIsLoading(true);
  
      const response = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}/products/category`
      );
  
      if (response.data?.status) {
        setCategoriesProd(response.data.data);
      } else {
        console.log("Category API failed:", response.data?.status_msg);
      }
    } catch (error) {
      console.log(
        "Get category error:",
        error?.response?.data || error.message
      );
    } finally {
      setIsLoading(false);
    }
  };
  const createProduct = async () => {
    if (!postTextArea || !selectedSubCategoryProd) {
      toast.show({
        render: () => <Toast color="red" message="Title & Category required" />,
        placement: "top",
      });
      return;
    }
  
    setIsSubmitting(true);
    const media = postImage.map((item) => ({
      url: item.url,
      type: mapMimeToMediaType(item.type),
    }));
  
    try {
      const payload = {
        title: postTextArea,
        details: postDetails,
        category_id: selectedSubCategoryProd?.id,
        media,
        tags,
      };
      // if (postImage.length > 0) {

      //   payload.media = postImage.map(item => item.url); 
      // }
     console.log("PayLoad",payload)
      const res = await axios.post(
        `${GlobalConstants.townTicksBaseUrl}/products`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Result image add",res)
      if (res.status === 200 || res.status === 201) {
        toast.show({
          render: () => (
            <Toast color="green" message="Product created successfully!" />
          ),
          placement: "top",
        });
  
        // Reset state
        setPostTextArea("");
        setPostDetails("");
        setPostImageProd([]);
        setTags([]);
        setSelectedSubCategoryProdId(null)
        setSelectedCategoryProd(null);
        setSelectedSubCategoryProd(null);
      } else {
        toast.show({
          render: () => (
            <Toast color="red" message="Something went wrong" />
          ),
          placement: "top",
        });
        setPostTextArea("");
        setPostDetails("");
      }
  
    } catch (error) {
      console.error("Create product error:", error);
      toast.show({
        render: () => (
          <Toast
            color="red"
            message={
              error?.response?.data?.message ||
              "Something went wrong. Please try again."
            }
          />
        ),
        placement: "top",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const mapMimeToMediaType = (mime) => {
    const imageTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "image/gif",
    ];
  
    const videoTypes = [
      "video/mp4",
      "video/quicktime",
      "video/mov",
    ];
  
    if (imageTypes.includes(mime)) return "IMAGE";
    if (videoTypes.includes(mime)) return "VIDEO";
  
    throw new Error("Unsupported media type");
  };

  const toggleTag = (tag) => {
    setTags(prev =>
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };


  const getProductsById = async (page = 1, reset = false) => {
    // If switching categories, reset the posts and page count
    if (reset) {
      setBusinessPosts([]);      
      setCurrentPage(1);         
      setHasMorePosts(true);     
      
    }
     console.log("entery 1")
    try {
      setIsLoadingMore(true); 
      const resp = await axios.get(
        `${GlobalConstants.townTicksBaseUrl}products?page=${page}`
      );
      console.log("entery 2",resp.data.status,resp.data)
      if (resp.data.status) {
        const newPosts = resp.data.data;
        console.log("result",newPosts)
        setBusinessPosts((prevPosts) => {
          // Replace list if reset or it's the first page, else append
          return reset || page === 1 ? newPosts : [...prevPosts, ...newPosts];
        });
        if (newPosts.length < 10) {
          setHasMorePosts(false);
        } else {
          setCurrentPage((prev) => (reset ? page + 1 : prev + 1));
        }
      } else {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.red}
              message={"Failed to get posts!"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoadingMore(false); 
    }
  };
  
//   const loadMorePostsForProduct = () => {
//   if (hasMorePosts && !isLoadingMore) {
    
//   }
// };

 ////// for scroll up to the top //////
 const [showUpButton, setShowUpButton] = useState(false);
  const scrollViewRef = useRef(null);
  const scrollToTop = () => {
    console.log("up to the screen.",scrollViewRef.current)
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };
  const handleScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowUpButton(scrollY > 100); // Show button when user scrolls down 100px
  };
  const removeImage = (indexToRemove) => {
    setPostImage((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  useEffect(async () => {
    console.log(window?.innerWidth || yourDefaultWidth);
    const updateLinkButton = () => {
      const toolbars = document.querySelectorAll(".ql-toolbar");

      toolbars.forEach((toolbar) => {
        const linkButton = toolbar.querySelector(".ql-formats");

        if (linkButton && !linkButton.classList.contains("customized")) {
          linkButton.classList.add("customized");

          const labelSpan = document.createElement("span");
          labelSpan.textContent = " Make hyperlink";
          labelSpan.style.marginLeft = "4px";
          labelSpan.style.fontSize = "14px";
          labelSpan.style.verticalAlign = "middle";

          linkButton.appendChild(labelSpan);
        }
      });
    };
    const editor1 = summaryRef.current?.getEditor();
    const editor2 = detailRef.current?.getEditor();

    if (editor1) {
      editor1.on("text-change", () => {
        const plain = editor1.getText().trim();
        if (plain.length > 300) {
          editor1.deleteText(300, plain.length);
        }
      });
    }

    if (editor2) {
      editor2.on("text-change", () => {
        const plain = editor2.getText().trim();
        if (plain.length > 1500) {
          editor2.deleteText(1500, plain.length);
        }
      });
    }

    // Apply the update after component mounts
    updateLinkButton();
    changeColor("AddTick");
    setGetTick(true);
  }, []);

  // for survey agent 
  // Survey → open inline AgentChatWidget; all others → show "coming soon" card
  const handleAgentPress = (serviceName) => {
    resetServiceViews();
    if (serviceName === "Survey") {
      setShowAgentChat(true);
    } else {
      setShowAgentComingSoon(true);
    }
  };

  return (
    <>
      <ScrollView ref={scrollViewRef} onScroll={handleScroll}
        scrollEventThrottle={16} >
        <Center>
          <Box safeAreaTop bg="white" />

          <Box
            bg="#F5F5F5"
            px="1"
            py="3"
            justifyContent="space-between"
            alignItems="center"
            w="100%"
            maxW="900"
          >
            <VStack alignItems="center">
              <Stack
                alignItems="center"
                flexDirection="column"
              >
                <Stack
                  mt={5}
                  w={[230, 430, 530]}
                  justifyContent="center"
                  flexDirection={"row"}
                >
                  <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={ticksBtnTextColorHead}
                    borderWidth={2}
                    onPress={() => {
                      changeColorHead("Ticks");
                      setGetTick(true);
                      setGetDeal(false);
                      setIsTicksView(true);
                      setGetServices(false);
                     setGetProducts(false);
                     setIsProductView(false);
                      // for survey agent — 
                      resetServiceViews();
                      getPostsByCategoryId(
                        GlobalConstants.postCategories.tick.id
                      );
                    }}
                    leftIcon={
                      <Image source={ {uri: getTick ? require("../../../assets/colorTick.png") : require("../../../assets/tick.png")}} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={ticksBtnTextColorHead}
                    >
                      Ticks
                    </Text>
                  </Button>

                  <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={dealsBtnTextColorHead}
                    borderWidth={2}
                    onPress={() => {
                      changeColorHead("Deals");
                      setGetDeal(true);
                      setGetTick(false);
                      setIsTicksView(true);
                      setGetServices(false);
                      setIsProductView(false);
                     setGetProducts(false);
                      // for survey agent
                      resetServiceViews();
                      getPostsByCategoryId(
                        GlobalConstants.postCategories.deal.id
                      );
                    }}
                    leftIcon={
                      <Image source={{ uri: getDeal ? require("../../../assets/colordeals.png") : require("../../../assets/deals.png")}} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={dealsBtnTextColorHead}
                    >
                      Deals
                    </Text>
                  </Button>
                  <Button
                  //isDisabled={true}
                    size="sm"
                    variant={"solid"}
                    mx={1}
                    px="3"
                    bg={GlobalStyles.colors.blue}
                    borderColor={createAdBtnTextColor}
                    borderWidth={2}
                    onPress={() => {
                      navigation.navigate("AdvertiserMainPage");
                    }}
                    leftIcon={
                      <Image source={require("../../../assets/ads.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={createAdBtnTextColor}
                    >
                       Ads
                    </Text>
                  </Button>
                  <Button
                  //isDisabled={true}
                   size="sm"
                   mx={1}
                   variant={"solid"}
                   px="3"
                   bg={GlobalStyles.colors.blue}
                   borderColor={servicesBtnTextColorHead}
                   borderWidth={2}
                   onPress={() => {
                     changeColorHead("services");
                     setGetDeal(false);
                     changeColor("services");
                     setGetTick(false);
                     setIsTicksView(false);
                     setGetServices(true);
                     setIsAgentOff(true);
                     setGetProducts(false);
                     setIsProductView(false);
                     // for survey agent 
                     resetServiceViews();
                   }}
                    leftIcon={
                      <Image source={require("../../../assets/icons_services.png")} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={servicesBtnTextColor}
                    >
                       Services
                    </Text>
                  </Button>
                  <Button
                   size="sm"
                   mx={1}
                   variant={"solid"}
                   px="3"
                   bg={GlobalStyles.colors.blue}
                   borderColor={productsBtnTextColorHead}
                   borderWidth={2}
                   onPress={() => {
                     changeColorHead("products");
                     setGetDeal(false);
                     changeColor("products");
                     
                     setGetTick(false);
                     setIsTicksView(false);
                     setGetServices(false);
                     getCategoryForProduct();
                     getListItems();
                     setGetProducts(true);
                     setIsProductView(false);
                     // for survey agent 
                     resetServiceViews();
                   }}
                    leftIcon={
                      <Image source={{uri: getProducts ? require("../../../assets/products.png"): require("../../../assets/ix_product.png")}} alt="icon" size="5"  />
                    }
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={productsBtnTextColor}
                    >
                       Products
                    </Text>
                  </Button>
                  
                </Stack>
                {getTick && (
                     <Stack
                     mt={window?.innerWidth < 415 ? 2 : 5}
                     w={[190, 190, 190]}
                     justifyContent="center"
                     flexDirection={"row"}
                     ml={2}
                   >
                    <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.white}
                    borderColor={ticksBtnTextColor}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("Ticks");
                      setIsTicksView(true);
                      getPostsByCategoryId(
                        GlobalConstants.postCategories.tick.id
                      );
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={ticksBtnTextColor}
                    >
                      Ticks
                    </Text>
                  </Button>
                     <Button
                       size="sm"
                       variant={"solid"}
                       mx={1}
                       px="3"
                       bg={GlobalStyles.colors.white}
                       borderColor={addTickBtnTextColor}
                       borderWidth={2}
                       borderRadius={40}
                       onPress={() => {
                        changeColor("AddTick")
                       }}
                     >
                       <Text
                         fontWeight="bold"
                         fontFamily={GlobalStyles.text.fontFamily}
                         color={addTickBtnTextColor}
                       >
                         Add Tick
                       </Text>
                     </Button>
                     
                     
                   </Stack>
                )}
                {getDeal && (
                     <Stack
                     mt={window?.innerWidth < 415 ? 2 : 5}
                     w={[190, 190, 190]}
                     justifyContent="center"
                     flexDirection={"row"}
                     ml={2}
                   >
                    <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.white}
                    borderColor={dealsBtnTextColor}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("Deals");
                      setGetDeal(true);
                      setIsTicksView(true);
                      getPostsByCategoryId(
                        GlobalConstants.postCategories.deal.id
                      );
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={dealsBtnTextColor}
                    >
                      Deals
                    </Text>
                  </Button>
                     
                     <Button
                       size="sm"
                       variant={"solid"}
                       mx={1}
                       px="3"
                       bg={GlobalStyles.colors.white}
                       borderColor={addDealBtnTextColor}
                       borderWidth={2}
                       borderRadius={40}
                       onPress={() => {
                         changeColor("AddDeal");
                       }}
                     >
                       <Text
                         fontWeight="bold"
                         fontFamily={GlobalStyles.text.fontFamily}
                         color={addDealBtnTextColor}
                       >
                         Add Deal
                       </Text>
                     </Button>
                     
                   </Stack>
                )}
              </Stack>

              {isTicksView ? (
                <>
                  <ScrollView
                    w={[350, 450, 610]}
                    showsVerticalScrollIndicator={false}
                    
                  >
                    <VStack alignItems="center">
                      <Stack
                        justifyContent="center"
                        flexDirection={"row"}
                        space={3}
                        flexWrap="wrap"
                        m={2}
                      >
                        {businessPosts.map((x, index) => {
                          return (
                            <FeedCardNew
                              data={x}
                              key={index}
                              showViewCount={false}
                              setSelectedPost={onDeleteClick}
                            />
                          );
                        })}
                      </Stack>
                    </VStack>
                    {businessPosts.length >= 10 && hasMorePosts && (
                    <Stack
                      w={[190, 190, 190]}
                      alignSelf="center"
                      
                    >
                      <Button
                         size="sm"
                         bg={GlobalStyles.colors.blue}
                         onPress={loadMorePosts}
                         isLoading={isLoadingMore} 
                         isLoadingText="Loading..."
                       >
                         <Text
                           fontWeight="bold"
                           fontFamily={GlobalStyles.text.fontFamily}
                           color={GlobalStyles.colors.white}
                         >
                           Load More
                         </Text>
                       </Button>
                    </Stack>
                   )}
                  </ScrollView>
                    
                </>
                
              ) : getServices ? (
                <>
                {/* for survey agent  */}
                {showAgentChat ? (
                  <AgentChatWidget
                    onBack={() => setShowAgentChat(false)}
                    serviceName="Survey"
                    userId={String(userId || "1")}
                    userToken={user?.token}
                  />
                ) : showAgentComingSoon ? (
                  // for survey agent 
                  <Card mt={10} w="100%" mx="auto" position="relative" p={6}>
                    <Button
                      size="sm"
                      position="absolute"
                      top="10px"
                      right="10px"
                      variant="ghost"
                      minW="auto"
                      p={2}
                      onPress={() => setShowAgentComingSoon(false)}
                    >
                      ✕
                    </Button>
                    <Center h="120px">
                      <Text fontSize="20px" color="black.500" fontWeight="bold">
                        Agent will come soon
                      </Text>
                    </Center>
                  </Card>
                ) : isAgentOff ? (
                  <>
                    {/* Conditional rendering of service components */}
                    {showTicketManager ? (
                        <TicketManager onBack={() => setShowTicketManager(false)} />
                      ) : showCouponManager ? (
                        <CouponManager onBack={() => setShowCouponManager(false)} />
                      ) : showReservation ? (
                        <BusinessReservation onBack={() => setShowReservation(false)} />
                      ) : showSurvey ? (
                        <BusinessSurvey onBack={() => setShowSurvey(false)} />
                      ) : showLoyaltyManager ? (
                        <LoyaltyManager onBack={() => setShowLoyaltyManager(false)} />
                      ) : showCustomerData ? (
                        <CustomerData onBack={() => setShowCustomerData(false)} />
                      ) : showSubscription ? (
                        <Subscription onBack={() => setShowSubscription(false)} />
                      ) : (
                      
                    <>

                      <Stack
                        w={[350, 450, 700]}
                        // borderWidth="2px"
                        // borderColor="blue.400"
                        borderRadius="md"
                        p={6}
                        mt={6}
                        mx="auto"
                      >
                        <VStack space={4} divider={<Divider />}>
                          {services.map((service, index) => (
                            <HStack
                              key={index}
                              justifyContent="space-between"
                              alignItems="center"
                            >
                            <HStack space={3} alignItems="center">
                              <Image source={service.icon} alt={service.name} size={5} />
                              <Text fontSize="16px" fontWeight="500">
                                {service.name}
                              </Text>
                            </HStack>

                                  <HStack space={3}>
                                    <SubscribeServiceButton
                                        serviceName={SERVICE_NAME_TO_KEY[service.name]}
                                        userId={userId}
                                        serviceInfo={serviceMap[SERVICE_NAME_TO_KEY[service.name]]}
                                        loggedInUser={user}
                                        onSubscribeSuccess={() => refetchServiceMap()}
                                      />

                                        {/*SERVICES NAVIGATION: Open button handler */}
                                        <Button
                                          size="sm"
                                          bg={GlobalStyles.colors.mustard}
                                          _hover={{ bg: GlobalStyles.colors.mustard }}
                                          onPress={() => {
                                            resetServiceViews();
                                            if (service.name === "Survey") {
                                              setShowSurvey(true);
                                            } else if (service.name === "Ticketing System") {
                                              setShowTicketManager(true);
                                            } else if (service.name === "Coupons") {
                                              setShowCouponManager(true);
                                            } else if (service.name === "Reservation System") {
                                              setShowReservation(true);
                                            } else if (service.name === "Loyalty Points") {
                                              setShowLoyaltyManager(true);
                                            } else if (service.name === "Customer Data & Email System") {
                                              setShowCustomerData(true);
                                            }
                                          }}
                                        >
                                          <Text
                                            color="black"
                                            fontFamily={GlobalStyles.text.fontFamily}
                                          >
                                            Open App
                                          </Text>
                                        </Button>
                                    {/* ==END SERVICES NAVIGATION */}

                                    {/* for survey agent  */}
                                    <Button
                                          size="sm"
                                          bg={GlobalStyles.colors.mustard}
                                          _hover={{ bg: GlobalStyles.colors.mustard }}
                                          onPress={() => {
                                            handleAgentPress(service.name);
                                          }}
                                        >
                                          <Text
                                            color="black"
                                            fontFamily={GlobalStyles.text.fontFamily}
                                          >
                                            Agent
                                          </Text>
                                        </Button>
                                  </HStack>
                                </HStack>
                              ))}
                          </VStack>
                          </Stack>
                          <HStack justifyContent="center" mt={5} space={4}>
                            <Button
                              bg={GlobalStyles.colors.blue}
                              _hover={{ bg: GlobalStyles.colors.blue }}
                            >
                              <Text color="white" fontFamily={GlobalStyles.text.fontFamily}>
                                Subscription-Management
                              </Text>
                            </Button>
                            <Button
                              bg={GlobalStyles.colors.mustard}
                              _hover={{ bg: GlobalStyles.colors.mustard }}
                              onPress={() => { resetServiceViews(); setShowSubscription(true); }}
                            >
                              <Text color="black" fontFamily={GlobalStyles.text.fontFamily}>
                                Open
                              </Text>
                            </Button>
                          </HStack>
                        </>
                      )}
                    </>
                ):(
                 <Card mt={10} w="100%" mx="auto" position="relative" p={6}>
                    {/* Cross Button Top Right */}
                    <Button
                      size="sm"
                      position="absolute"
                      top="10px"
                      right="10px"
                      variant="ghost"
                      minW="auto"
                      p={2}
                      onPress={() => setIsAgentOff(true)}
                    >
                      ✕
                    </Button>
                    {/* Center Text */}
                    <Center h="120px">
                      <Text fontSize="20px" color="black.500" fontWeight="bold">
                       Agent will come soon
                      </Text>
                    </Center>
                  </Card>
                )}
                </>
              ) : getProducts ? (
                <>
                <Stack
                     mt={window?.innerWidth < 415 ? 2 : 5}
                     w={[190, 190, 190]}
                     justifyContent="center"
                     flexDirection={"row"}
                     ml={2}
                   >
                    <Button
                    size="sm"
                    mx={1}
                    variant={"solid"}
                    px="3"
                    bg={GlobalStyles.colors.white}
                    borderColor={getAdProduct}
                    borderWidth={2}
                    borderRadius={40}
                    onPress={() => {
                      changeColor("AddProduct");
                      setIsTicksView(false);
                      setGetDeal(false);
                     
                     setGetTick(false);
                     setGetServices(false);
                     setGetProducts(true);
                     setIsProductView(true);
                      getProductsById();
                    }}
                  >
                    <Text
                      fontWeight="bold"
                      fontFamily={GlobalStyles.text.fontFamily}
                      color={getAdProduct}
                    >
                      Added Products
                    </Text>
                  </Button>
                     <Button
                       size="sm"
                       variant={"solid"}
                       mx={1}
                       px="3"
                       bg={GlobalStyles.colors.white}
                       borderColor={createAdProduct}
                       borderWidth={2}
                       borderRadius={40}
                       onPress={() => {
                        changeColor("Product");
                        setIsTicksView(false);
                        setGetDeal(false);
                        getCategoryForProduct();
                        getListItems();
                        setGetTick(false);
                        setGetServices(false);
                        setGetProducts(true);
                        setIsProductView(false);
                       }}
                     >
                       <Text
                         fontWeight="bold"
                         fontFamily={GlobalStyles.text.fontFamily}
                         color={createAdProduct}
                       >
                         Add Product
                       </Text>
                     </Button>
                     <Button
                       size="sm"
                       variant={"solid"}
                       mx={1}
                       px="3"
                       bg={GlobalStyles.colors.white}
                       borderColor={GlobalStyles.colors.blue}
                       borderWidth={2}
                       borderRadius={40}
                      //  onPress={() => {
                      //   changeColor("AddTick")
                      //  }}
                     >
                       <Text
                         fontWeight="bold"
                         fontFamily={GlobalStyles.text.fontFamily}
                         color={GlobalStyles.colors.blue}
                       >
                         Analytics
                       </Text>
                     </Button>
                     
                     
                </Stack>
                {isProductView ?(
                  <>
                  <ScrollView
                    w={[350, 450, 610]}
                    showsVerticalScrollIndicator={false}
                    
                  >
                    <VStack alignItems="center">
                      <Stack
                        justifyContent="center"
                        flexDirection={"row"}
                        space={3}
                        flexWrap="wrap"
                        m={2}
                      >
                        {businessPosts.map((x, index) => {
                          return (
                            <AdProductCardForBusiness
                              data={x}
                              key={index}
                              showViewCount={false}
                              setSelectedPost={onDeleteClickProduct}
                            />
                          );
                        })}
                      </Stack>
                    </VStack>
                    {businessPosts.length >= 10 && hasMorePosts && (
                    <Stack
                      w={[190, 190, 190]}
                      alignSelf="center"
                      
                    >
                      <Button
                         size="sm"
                         bg={GlobalStyles.colors.blue}
                         onPress={loadMorePosts}
                         isLoading={isLoadingMore} 
                         isLoadingText="Loading..."
                       >
                         <Text
                           fontWeight="bold"
                           fontFamily={GlobalStyles.text.fontFamily}
                           color={GlobalStyles.colors.white}
                         >
                           Load More
                         </Text>
                       </Button>
                    </Stack>
                   )}
                  </ScrollView>
                    
                </>
                ):(
                  <>
                  <ScrollView bg={COLORS.bg} py={4} px={10} width="max-content">
                {/* ---------------- TOGGLE ---------------- */}
                <HStack px={10} py={8} width="80%" alignItems="flex-start">

                  {/* ================= LEFT SECTION ================= */}
                  <VStack>

                    {/* Add Single / Add Bulk */}
                    <HStack space={10} alignItems="center">
                      <Pressable onPress={() => setAddMode("single")}>
                        <HStack space={2} alignItems="center">
                          <Ionicons
                            name={addMode === "single" ? "radio-button-on" : "radio-button-off"}
                            size={16}
                            color="#0A1B6F"
                          />
                          <Text fontSize="sm">Add Single</Text>
                        </HStack>
                      </Pressable>

                      <Pressable onPress={() => setAddMode("bulk")}>
                        <HStack space={2} alignItems="center">
                          <Ionicons
                            name={addMode === "bulk" ? "radio-button-on" : "radio-button-off"}
                            size={16}
                            color="#0A1B6F"
                          />
                          <Text fontSize="sm">Add Bulk</Text>
                        </HStack>
                      </Pressable>
                    </HStack>

                    {/* ================= ADD SINGLE ================= */}
                    {addMode === "single" ? (
                      <HStack mt={6} width="80%" alignItems="flex-start">

                        {/* LEFT FORM */}
                        <VStack width="40%" space={6}>

                          <Button
                            bg="#0A1B6F"
                            width="160px"
                            height="42px"
                            onPress={selectFileProd}
                            isLoading={isLoading}
                            isLoadingText="Uploading"
                            isDisabled={isLoading}
                            borderRadius={2}
                            rightIcon={
                              !isLoading && (
                                <Image
                                  source={require("../../../assets/uploadimg.png")}
                                  alt="Upload"
                                  size={4}
                                />
                              )
                            }
                          >
                            <Text color="#fff" fontSize="sm">Upload Image</Text>
                          </Button>
                           {/* ---------- PREVIEW ---------- */}
                      <HStack flexWrap="wrap" mt={3} space={2}>
                        {Array.isArray(postImage) && postImage.map((img, idx) => (
                          <Box key={idx} position="relative">
                            <Image
                              source={{ uri:img.url}}
                              alt={"video/mp4"}
                              size="md"
                              borderRadius={8}
                            />
                            <Pressable
                              position="absolute"
                              top={0}
                              right={0}
                              bg="red.500"
                              borderRadius="full"
                              p={1}
                              onPress={() => removeImage(idx)}
                            >
                              <Icon
                                as={<MaterialIcons name="close" />}
                                size="xs"
                                color="white"
                              />
                            </Pressable>
                          </Box>
                        ))}
                      </HStack>

                      <FormControl mt={2} w={[150, 200, 250]} style={{ overflow: 'hidden' }}>

                          <Box
                              borderColor="gray.300"
                              borderWidth={1}
                              
                              p={2}
                              minHeight={150}
                              maxHeight={170} 
                              overflow="hidden" 
                              bgColor="white"
                            >
                              <ReactQuill
                                theme="snow"
                                ref={summaryRef}
                                value={postTextArea}
                                onChange={(value) => handleCountInputChange(value)}  // for web
                                onChangeText={(text) => handleCountInputChange(text)} // for android and ios
                                modules={{
                                  toolbar: [
                                    
                                    ["link"],
                                  ],
                                }}
                                formats={["link"]}
                                placeholder="Write Product Brief and give link"
                                
                                // maxLength={300}
                              />
                              <style>
                              {`
                                .ql-toolbar {
                                  position: sticky;
                                  top: 0;
                                  background-color: white;
                                  z-index: 10;
                                }

                                .ql-container {
                                  max-height: 110px;
                                  overflow-y: auto;
                                  min-height:70px
                                }

                                .ql-tooltip {
                                  left: 0 !important;
                                  transform: translateX(0) !important;
                                  max-width: 100% !important;
                                  overflow: hidden !important;
                                  white-space: nowrap;
                                }
                              `}
                              </style>
                            </Box>


                          </FormControl>
                          <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharacters === 0 ? "red.500" : "gray.500"}> 
                          {remainingCharacters === 0
                          ? "Character limit reached"
                          : `${remainingCharacters} characters remaining`}
                          </Text>


                          <FormControl mt={2} w={[150, 200, 250]} style={{ overflow: 'hidden' }}>
                          <Box
                            borderColor="gray.300"
                            borderWidth={1}
                            
                            p={2}
                            minHeight={150}
                            maxHeight={170} 
                            overflow="hidden" 
                            bgColor="white"
                          >
                            <ReactQuill
                              theme="snow"
                              ref={detailRef}
                              value={postDetails}
                              onChange={(value) => handleCountInputChangeForDetail(value)} // for web
                              onChangeText={(text) => handleCountInputChangeForDetail(text)} // for android and ios
                              modules={{
                                toolbar: [
                                  
                                  ["link"],
                                ],
                              }}
                              formats={["link"]}
                              placeholder="Write the details here...(optional)"
                              // maxLength={1500}
                            />
                          </Box>
                          </FormControl>
                          <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharactersForDetail === 0 ? "red.500" : "gray.500"}> 
                          {remainingCharactersForDetail === 0
                          ? "Character limit reached"
                          : `${remainingCharactersForDetail} characters remaining`}
                          </Text>

                          {/* Tag Box */}
                          <Box borderWidth={1} borderColor="#000" p={4}>
                            <Text mb={3} fontWeight="500">Tag</Text>

                            <HStack space={8}>
                            <Pressable onPress={() => toggleTag("Popular")}>
                              <HStack space={2} alignItems="center">
                                <Ionicons
                                  name={tags.includes("Popular") ? "radio-button-on" : "radio-button-off"}
                                  size={16}
                                />
                                <Text>Popular</Text>
                              </HStack>
                            </Pressable>   
                             <Pressable onPress={() => toggleTag("New Arrival")}>
                              <HStack space={2} alignItems="center">
                                <Ionicons
                                  name={tags.includes("New Arrival") ? "radio-button-on" : "radio-button-off"}
                                  size={16}
                                />
                                <Text>New Arrival</Text>
                              </HStack>
                            </Pressable>
                            </HStack>
                          </Box>
                        </VStack>

                        {/* DIVIDER */}
                        <Box mx={12} height="420px" width="1px" bg="#F5A400" />

                        {/* ================= RIGHT SECTION ================= */}
                        <VStack width="50%" space={6}>

                          <HStack space={10} alignItems="flex-start">

                            <VStack space={3}>
                              <Text color="#0A1B6F" fontWeight="600">
                                Select Category & Sub Category
                              </Text>

                              {categoriesProd.map((item) => {
                                const isCategorySelected = selectedCategoryProd?.id === item.id;

                                return (
                                  <VStack key={item.id} space={2}>
                                    {/* CATEGORY */}
                                    <Pressable onPress={() => handleCategorySelect(item)}>
                                      <HStack space={2} alignItems="center">
                                        <Image
                                          source={{
                                            uri: isCategorySelected
                                              ? toggleImages.on
                                              : toggleImages.off,
                                          }}
                                          alt="Toggle"
                                          size={4}
                                        />
                                        <Text
                                          color={isCategorySelected ? "#F5A400" : "#000"}
                                        >
                                          {item.name}
                                        </Text>
                                      </HStack>
                                    </Pressable>

                                    {/* SUB-CATEGORY UNDER SELECTED CATEGORY */}
                                    {isCategorySelected &&
                                      subCategoriesProd.map((sub) => (
                                        <Pressable
                                          key={sub.id}
                                          onPress={() => handleSubCategorySelect(sub)}
                                        >
                                          <HStack
                                            space={2}
                                            alignItems="center"
                                            pl={6} // 👈 indent under category
                                          >
                                            <Image
                                              source={{
                                                uri:
                                                  selectedSubCategoryProd?.id === sub.id
                                                    ? toggleImages.on
                                                    : toggleImages.off,
                                              }}
                                              alt="Toggle"
                                              size={3}
                                            />
                                            <Text
                                              color={
                                                selectedSubCategoryProd?.id === sub.id
                                                  ? "#F5A400"
                                                  : "#000"
                                              }
                                            >
                                              {sub.name}
                                            </Text>
                                          </HStack>
                                        </Pressable>
                                      ))}
                                  </VStack>
                                );
                              })}
                            </VStack>

                            {/* Selected */}
                            <VStack space={3}>
                              <Text color="#0A1B6F" fontWeight="600">Selected</Text>

                              <Box borderWidth={1} borderColor="#000" px={4} py={2}>
                                <Text>
                                  {selectedCategoryProd && selectedSubCategoryProd
                                    ? `${selectedCategoryProd.name} - ${selectedSubCategoryProd.name}`
                                    : "None"}
                                </Text>
                              </Box>
                              <Button
                                    bg="#0A1B6F"
                                    borderRadius={0}
                                    onPress={handleMoveToList}
                                    px={4}
                                    py={2}
                                  >
                                    <HStack
                                      width="100%"
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Text color="#fff" fontWeight="bold">
                                        Move to List
                                      </Text>

                                      <Image
                                        source={require("../../../assets/moveToList.png")}
                                        alt="Move"
                                        size={4}
                                        ml={2}
                                      />
                                    </HStack>
                                  </Button>
                            </VStack>
                          </HStack>
                      <VStack alignItems="center" space={6} >
                          {/* OR */}
                          <Text color="#0A1B6F" mt={6}>OR</Text>

                          {/* List */}
                          <VStack space={3}>
                            <Text color="#0A1B6F" fontWeight="600">Chose from List</Text>

                            {listItems.map((item) => (
                              <Pressable
                              key={item.id}
                              onPress={() => setSelectedSubCategoryProdId(item.category_id)}
                            >
                              <HStack
                                justifyContent="space-between"
                                alignItems="center"
                                px={4}
                                py={2}
                                bg={selectedSubCategoryProdId === item.id ? "#EEF2FF" : "transparent"}
                              >
                                <HStack space={2} alignItems="center">
                                  <Image source={{ uri: toggleImages.off }} alt="item" size={4} />
                                  <Text>{item.label}</Text>
                                </HStack>
                          
                                <Pressable onPress={() => handleRemoveItem(item.category_id)}>
                                  <Ionicons name="close" size={16} />
                                </Pressable>
                              </HStack>
                            </Pressable>
                            ))}
                          </VStack>

                          {/* Submit */}
                          <Button
                            mt={8}
                            alignSelf="center"
                            bg="#0A1B6F"
                            px={8}
                            isDisabled={user?.email !== "usman.786@novelma.com" && user?.email!== "novelma.dubai@townticks.com"  }
                            onPress={createProduct}
                                isLoading={isSubmitting}
                                // isDisabled={isSubmitting}
                                rightIcon={
                                  !isSubmitting && (
                                    <Image
                                      source={require("../../../assets/productSubmit.png")}
                                      alt="Submit"
                                      size={4}
                                    />
                                  )
                                }
                              >
                            <Text color="#F5A400">Submit</Text>
                          </Button>
                        </VStack>
                        </VStack>
                      </HStack>
                    ) : (
                      /* ================= ADD BULK ================= */
                      <VStack
                        mt={6}
                        alignItems="center"
                        justifyContent="center"
                        borderWidth={1}
                        borderColor="#ddd"
                        py={10}
                      >
                        <Text fontSize="md" color="#999">🚧 Upcoming Feature</Text>
                      </VStack>
                    )}
                  </VStack>
                </HStack>
                </ScrollView>
                  </>
                )}
                
              </>
              ):(
                <>
                  <Box mt={10} alignItems="center" w={[250, 350, 400]}>
                    {/* Image Upload */}
                    <FormControl mt={2} w={[250, 350, 400]}>
                      <Pressable
                        onPress={() => {
                          selectFile();
                        }}
                      >
                        <Input
                          value={
                            postImage.length > 0
                              ? `${postImage.length} image(s) selected`
                              :  "Upload Images / Videos"
                          }
                          InputRightElement={
                            <Button
                              onPress={() => {
                                selectFile();
                              }}
                              bgColor="gray.200"
                            >
                              <Icon
                                size="6"
                                color="muted.500"
                                as={<MaterialIcons name="file-upload" />}
                              />
                            </Button>
                          }
                        />
                      </Pressable>
                      {/* ---------- PREVIEW ---------- */}
                      <HStack flexWrap="wrap" mt={3} space={2}>
                        {Array.isArray(postImage) && postImage.map((img, idx) => (
                          <Box key={idx} position="relative">
                            <Image
                              source={{ uri:img}}
                              alt={"video/mp4"}
                              size="md"
                              borderRadius={8}
                            />
                            <Pressable
                              position="absolute"
                              top={0}
                              right={0}
                              bg="red.500"
                              borderRadius="full"
                              p={1}
                              onPress={() => removeImage(idx)}
                            >
                              <Icon
                                as={<MaterialIcons name="close" />}
                                size="xs"
                                color="white"
                              />
                            </Pressable>
                          </Box>
                        ))}
                      </HStack>

                    </FormControl>

                    
                    <FormControl mt={2} w={[250, 350, 400]} style={{ overflow: 'hidden' }}>

                      <Box
                          borderColor="gray.300"
                          borderWidth={1}
                          ref={boxRef}
                          p={2}
                          minHeight={150}
                          maxHeight={170} 
                          overflow="hidden" 
                          bgColor="white"
                        >
                          <ReactQuill
                            theme="snow"
                            ref={summaryRef}
                            value={postTextArea}
                            onChange={(value) => handleCountInputChange(value)}  // for web
                            onChangeText={(text) => handleCountInputChange(text)} // for android and ios
                            modules={{
                              toolbar: [
                                
                                ["link"],
                              ],
                            }}
                            formats={["link"]}
                            placeholder="Summary"
                            
                            // maxLength={300}
                          />
                          <style>
                          {`
                            .ql-toolbar {
                              position: sticky;
                              top: 0;
                              background-color: white;
                              z-index: 10;
                            }

                            .ql-container {
                              max-height: 110px;
                              overflow-y: auto;
                            }

                            .ql-tooltip {
                              left: 0 !important;
                              transform: translateX(0) !important;
                              max-width: 100% !important;
                              overflow: hidden !important;
                              white-space: nowrap;
                            }
                          `}
                          </style>
                        </Box>

                      
                    </FormControl>
                    <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharacters === 0 ? "red.500" : "gray.500"}> 
                    {remainingCharacters === 0
                    ? "Character limit reached"
                    : `${remainingCharacters} characters remaining`}
                    </Text>

                    
                    <FormControl mt={2} w={[250, 350, 400]} style={{ overflow: 'hidden' }}>
                      <Box
                        borderColor="gray.300"
                        borderWidth={1}
                        ref={box2Ref}
                        p={2}
                        minHeight={150}
                        maxHeight={170} 
                        overflow="hidden" 
                        bgColor="white"
                      >
                        <ReactQuill
                          theme="snow"
                          ref={detailRef}
                          value={postDetails}
                          onChange={(value) => handleCountInputChangeForDetail(value)} // for web
                          onChangeText={(text) => handleCountInputChangeForDetail(text)} // for android and ios
                          modules={{
                            toolbar: [
                              
                              ["link"],
                            ],
                          }}
                          formats={["link"]}
                          placeholder="Write the details here..."
                          // maxLength={1500}
                        />
                      </Box>
                    </FormControl>
                    <Text alignSelf={"flex-end"} fontSize="xs" color={remainingCharactersForDetail === 0 ? "red.500" : "gray.500"}> 
                    {remainingCharactersForDetail === 0
                    ? "Character limit reached"
                    : `${remainingCharactersForDetail} characters remaining`}
                    </Text>
                    <Button
                     isLoading={isLoading}
                      size="sm"
                      variant={"solid"}
                      mx={1}
                      px="3"
                      bg={GlobalStyles.colors.blue}
                      borderColor={GlobalStyles.colors.mustard}
                      borderWidth={2}
                      onPress={() => {
                        createPost();
                      }}
                    >
                      <Text
                        fontWeight="bold"
                        fontFamily={GlobalStyles.text.fontFamily}
                        color={GlobalStyles.colors.white}
                      >
                        Submit
                      </Text>
                    </Button>
                  </Box>
                </>
              )}
            </VStack>
            {deletePopUp ? (
              <ConfigureSettingsPopup
                heading="Confirm Deletion"
                body="Are you sure you want to delete"
                data={deletePopUp}
                onChange={handleDeleteOk}
              />
            ) : (
              <></>
            )}
            {deletePopUpProduct ? (
              <ConfigureSettingsPopup
                heading="Confirm Deletion"
                body="Are you sure you want to delete"
                data={deletePopUpProduct}
                onChange={handleDeleteOkProduct}
              />
            ) : (
              <></>
            )}
          </Box>
        </Center>
      </ScrollView>
      {showUpButton && isTicksView && (
         <IconButton
         position="absolute"
         bottom={10}
         right={10}
         borderRadius="full"
         bg={GlobalStyles.colors.blue}
         _pressed={{ bg: "gray.500" }}
         icon={<ChevronUpIcon color="white" size={6} />}
         onPress={scrollToTop}
       />
      )}
    </>
  );
};

export default BusinessMainPage;